import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./MediclaimResponse.module.css";
import moment from "moment";
import { fetchClaimHistory } from "../../../../redux";
import * as Yup from "yup";
import {
    Button,
} from "reactstrap";
import ttmLoader from "../../../../assets/images/ttm-loader.gif";
import { Select } from "antd";
import { checkIfPermitted, Permissions } from "../../../../services/RolePermissionService";
import history from "../../../../utils/history";
import { LineItemResponseSection } from "./LineItemResponseSection";

const { Option } = Select;


function dateFormatter(cell) {
    if (!cell) {
        return "";
    }
    return `${
        moment(cell).format("YYYY-MM-DD")
            ? moment(cell).format("YYYY-MM-DD")
            : moment(cell).format("YYYY-MM-DD")
        }`;
}

export class MediclaimResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            sortName: "",
            sortOrder: "",
            sortBy: "",
            isDataFetched: false,
            claimHistory: [],
        };
        this.setLoader = this.setLoader.bind(this);
    }
    // Adding actions edit and delete icons
    actionsFormatter(cell, row) {
        return (
            <div>
                <Link title="Add Diagnosis">
                    <i className="fa fa-plus relatedpartylist-edit-icon"></i>
                </Link>
            </div>
        );
    }

    componentDidMount = async () => {

        if (this.props.match && this.props.match.params && this.props.match.params.id) {

            await this.props.fetchClaimHistory(this.props.match.params.id);
        }

        if (this.props.claimHistoryData &&
            this.props.claimHistoryData.claimHistory &&
            this.props.claimHistoryData.claimHistory) {
            this.setState({
                claimHistory: this.props.claimHistoryData.claimHistory
            })
        }
        setTimeout(() => {
                this.setState({
                    isDataFetched: true,
                });
        }, 1000);

    }


    onSortChange = (sortName, sortOrder) => {
        let sortBy;
        if (sortOrder == "desc") {
            sortBy = "-" + sortName;
        } else {
            sortBy = sortName;
        }
        this.setState({
            sortName,
            sortOrder,
            sortBy,
            page: 1,
            isDataFetched: false,
        }, () => {
            //this.callListAPI();
        });

    };

    onPageChange = (page, sizePerPage) => {
        this.setState({
            page,
            isDataFetched: false
        }, () => {
            // this.callListAPI();
        });
    };


    /**
     * This method will be called when there is not data or data is being fetched to show the loader.
     */
    setLoader = () => {
        if (this.state.isDataFetched) {
            return <p>There is no data to display</p>;
        } else {
            return (
                <div>
                    <img src={ttmLoader} alt='loader' className="loader-image" />
                </div>
            );
        }
    }

    /**
    * This method will be called to format the table data for valid data.
    * @param {string} data of the table column.
    * @returns {string} data or Not available string
    */
    checkValidData = (data) => {
        if (!data) {
            return "NA";
        } else {
            return data;
        }
    }

    /**
    * This method will be called to format the table data for valid data.
    * @param {string} data of the table column.
    * @returns {string} data with first letter capital or Not available string
    */
    detailFormatter = (data) => {
        if (!data) {
            return "NA";
        } else {
            return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
        }
    }

    doctorNameFormat = (cell, row) => {
        if (!cell) {
            return "NA";
        } else {
            return ((cell ? (cell.charAt(0).toUpperCase() + cell.slice(1)) : "") + " " +
                (row.surname ? (row.surname.charAt(0).toUpperCase() + row.surname.slice(1)) : ""))
        }
    }


    statusFormat = (cell, row) => {
        if (!cell && !row.status) {
            return "NA";
        } else {
            return (cell + " - " + (row.status ? (row.status.charAt(0).toUpperCase() + row.status.slice(1)) : ""))
        }
    }

    goBack = () => {
        history.goBack();
    }

    checkResposneData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.response_code + " " + item.response_description}
                    </p>
                ))
                )}
            </div>
        );
    }

    // checkFailureResponseData = (data) => {
    //     if (!data || (data && JSON.parse(data).length === 0)) {
    //         return "Not Available";
    //     }

    //     let response = JSON.parse(data);
    //     return (
    //         <div>
    //             {(response && response.map((item, index) => (
    //                 <p className="mb-0">
    //                     {item.message}
    //                 </p>
    //             ))
    //             )}
    //         </div>
    //     );
    // }

    checkGeneralCommentsData = (data) => {
        if (!data || (data && JSON.parse(data).length === 0)) {
            return "Not Available";
        }

        let response = JSON.parse(data);

        return (
            <div>
                {(response && response.map((item, index) => (
                    <p className="mb-0">
                        {item.comment}
                    </p>
                ))
                )}
            </div>
        );

    }


    render() {
        const claimHistoryData = this.state.claimHistory;

        return (
            <div className={`inventory-tab-wrapper flex-wrap ${style.mediclaimResponseWrapper}`}>
                <div className="row">
                    <div className="col-lg-12">
                        <h3>Claim Response</h3>
                    </div>
                    {/* <div className="col-lg-12 intro-text">
                        <p className="mb-4">

                        </p>
                    </div> */}
                </div>

                <div className={`row ${style.mediclaimResponseBox}`}>
                    <div className={`col-md-4`}>
                        <label>Patient Name:</label>&nbsp;
                        {claimHistoryData && claimHistoryData.invoice && this.checkValidData(claimHistoryData.invoice.name)}
                    </div>
                    <div className={`col-md-4 textCenter`}>
                        <label>Diagnosis Code:</label>&nbsp;
                        {claimHistoryData && claimHistoryData.treatement && claimHistoryData.treatement[0] && this.checkValidData(claimHistoryData.treatement[0].diagnosis_code)}
                    </div>
                    <div className={`col-md-4 d-flex justify-content-start justify-content-md-end`}>
                        <label>Claim Date:</label>&nbsp;
                        {claimHistoryData && claimHistoryData.invoice && dateFormatter(claimHistoryData.invoice.service_start_date)}
                    </div>
                    <div className={`col-md-12`}>
                        <div class="claim-wrapper">
                            <div class="claim-response-table">
                                <div class="claim-response-header d-flex align-items-center justify-content-between">

                                    <div class="claim-response-col line-col">Line Type</div>
                                    <div class="claim-response-col tariff-col">Tariff Code</div>
                                    <div class="claim-response-col nappi-col">Nappi Code</div>
                                    <div class="claim-response-col desc-col">Description</div>
                                    {/* <div class="claim-response-col dia-col">Dia. Code</div> */}
                                    <div class="claim-response-col name-col">Doc./Asst. Name</div>
                                    <div class="claim-response-col quantity-col">Qty.</div>
                                    <div class="claim-response-col price-col">Price (ZAR)</div>
                                    <div class="claim-response-col status-col">Status</div>
                                    {/* <div class="claim-response-col del-indicator-col">Del. Indicator</div>             */}
                                    <div class="claim-response-col action-col"></div>
                                </div>

                                <div>
                                    {claimHistoryData && claimHistoryData.treatement &&
                                        claimHistoryData.treatement.map((item, index) => (
                                            <LineItemResponseSection data={item} key={index} />
                                        ))}
                                        {claimHistoryData && claimHistoryData.treatement &&
                                         claimHistoryData.treatement.length === 0 &&
                                         (<div className="textCenter">
                                             { this.setLoader()}
                                         </div>)}
                                </div>


                            </div>
                        </div>
                    </div>


                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div>
                            <Button
                                className="ttm-primary-btn"
                                type="button"
                                onClick={this.goBack}
                            >
                                Back
                                                                    </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// export default Users;
const mapStateToProps = (state) => {
    return {
        claimHistoryData: state.claimHistory,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchClaimHistory: (invoice_id) => dispatch(fetchClaimHistory(invoice_id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediclaimResponse);
